import { AxiosError } from 'axios'

import { authUrls, config } from '../config'
import { clearToken } from './cookie'

const UNAUTHORIZED_USER_CODE = 401

export const unauthorizedRedirect = (
  locale: string,
  error: AxiosError,
  redirectUrl?: string
) => {
  if (UNAUTHORIZED_USER_CODE === error.response?.status) {
    clearToken(config.cookiesDomain)

    const redirectParam = redirectUrl ? `?redirectUrl=${redirectUrl}` : ''
    location.href = authUrls(locale).signIn + redirectParam
  }
}
